import { render, staticRenderFns } from "./WalletManagement.vue?vue&type=template&id=341f61aa&scoped=true"
import script from "./WalletManagement.vue?vue&type=script&lang=js"
export * from "./WalletManagement.vue?vue&type=script&lang=js"
import style0 from "./WalletManagement.vue?vue&type=style&index=0&id=341f61aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341f61aa",
  null
  
)

export default component.exports